module.exports = __webpack_public_path__ + "static/contact-hero-84f14e8f5cbb713fd04325bdeb092ad7.jpg";